export const isMongoObjectId = (id) =>
  typeof id === "string" && /^[a-f\d]{24}$/i.test(id);

/** Strip client UUIDs and timestamps before PATCH; keep only valid MongoDB _id values. */
export const sanitizePhoneListForApi = (phones = []) =>
  phones.map(({ prefix, number, _id }) => {
    const entry = {
      prefix: prefix ?? "",
      number: number ?? "",
    };

    if (isMongoObjectId(_id)) {
      entry._id = _id;
    }

    return entry;
  });
